import { View } from "./Tasks.view";

export const Container = () => {
  return <View />;
};
